module.exports = __webpack_public_path__ + "img/carousel-item-1.3d1fe070.png";